





























import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionInfoListModel from '@/models/extension/extensionInfoListModel'
import InfoItemList from '@/components/lists/InfoItemList.vue'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'
import ExtensionModule from '@/store/extensionModule'
import StageConstants from '@/constants/stageConstants'
import LoadingIndicator from '@/components/loading/LoadingIndicator.vue'
import ExtensionInfoItemNoteModel from '../models/extension/extensionInfoItemNoteModel'
import Validation from '@/mixins/validation'

const titleModule = getModule(TitleModule)
const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    InfoItemList,
    AddDialog,
    LoadingIndicator
  }
})
export default class Stage extends Validation {
  @Prop(String) readonly stage!: string
  @Prop(String) readonly id!: string

  private stageKey: string = ''
  private dialog: boolean = false
  private infos: Array<ExtensionInfoListModel> = []
  private loading: boolean = true
  private note: ExtensionInfoItemNoteModel = new ExtensionInfoItemNoteModel()
  private listDisabled: boolean = false

  get formattedStage() {
    const stageName = this.stage.replace(/-/g, ' ')
    return stageName.charAt(0).toUpperCase() + stageName.slice(1)
  }

  private async created() {
    this.stageKey = StageConstants.getKeyByValue(this.stage)
    titleModule.setPageTitle(this.formattedStage)
    await this.getCategories()
  }

  private async getCategories(): Promise<void> {
    this.listDisabled = true

    try {
      this.infos = await ApiService.getQuestions<ExtensionInfoListModel>(
        UrlType.ExtensionInfo,
        extensionModule.getExtensionId,
        this.stageKey,
        this.id + `?nocache=${new Date().getTime()}`
      )
    } finally {
      this.loading = false
      this.listDisabled = false
    }
  }

  private async editNoteNotes(noteId: string): Promise<void> {
    this.note = await ApiService.get(UrlType.ExtensionInfoItemNote, noteId)

    this.dialog = true
  }

  private async saveNotes(valid: boolean): Promise<void> {
    if (valid) {
      await ApiService.put(
        UrlType.ExtensionInfoItemNote,
        this.note.extensionInfoItemNoteId,
        this.note
      )

      this.dialog = false
    }
  }
}
